var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacancy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7819 16.2498C33.7819 20.438 30.3867 23.8332 26.1986 23.8332C22.0104 23.8332 18.6152 20.438 18.6152 16.2498C18.6152 12.0617 22.0104 8.6665 26.1986 8.6665C30.3867 8.6665 33.7819 12.0617 33.7819 16.2498Z",
    fill: "#00558C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.4486 16.2502C42.4486 19.2417 40.0234 21.6668 37.0319 21.6668C34.0404 21.6668 31.6152 19.2417 31.6152 16.2502C31.6152 13.2586 34.0404 10.8335 37.0319 10.8335C40.0234 10.8335 42.4486 13.2586 42.4486 16.2502Z",
    fill: "#00558C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.94987 16.2502C9.94987 19.2417 12.375 21.6668 15.3665 21.6668C18.3581 21.6668 20.7832 19.2417 20.7832 16.2502C20.7832 13.2586 18.3581 10.8335 15.3665 10.8335C12.375 10.8335 9.94987 13.2586 9.94987 16.2502Z",
    fill: "#00558C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1992 35.7498C39.1992 39.938 33.3789 43.3332 26.1992 43.3332C19.0195 43.3332 13.1992 39.938 13.1992 35.7498C13.1992 31.5617 19.0195 28.1665 26.1992 28.1665C33.3789 28.1665 39.1992 31.5617 39.1992 35.7498Z",
    fill: "#00558C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.8665 35.7502C47.8665 38.7417 43.9863 41.1668 39.1999 41.1668C34.4134 41.1668 30.5332 38.7417 30.5332 35.7502C30.5332 32.7586 34.4134 30.3335 39.1999 30.3335C43.9863 30.3335 47.8665 32.7586 47.8665 35.7502Z",
    fill: "#00558C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.5319 35.7502C4.5319 38.7417 8.4121 41.1668 13.1986 41.1668C17.985 41.1668 21.8652 38.7417 21.8652 35.7502C21.8652 32.7586 17.985 30.3335 13.1986 30.3335C8.4121 30.3335 4.5319 32.7586 4.5319 35.7502Z",
    fill: "#00558C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancy);
export default __webpack_public_path__ + "static/media/vacancy.9e5f6411219093e93b9256643671e687.svg";
export { ForwardRef as ReactComponent };